module.exports = __webpack_public_path__ + "assets/img/icon-newmember-2.4d9c2928.svg";